import { Component, OnInit, ViewChild } from '@angular/core';
import { ProposalsAndOrdersService } from 'src/app/services/api/proposals-and-orders.api.service';
import { StorageService } from 'src/app/services/storage.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Company } from 'src/app/classes/Company.class';

@Component({
  selector: 'proposals-and-orders',
  templateUrl: './proposals-and-orders.screen.html',
  styleUrls: ['./proposals-and-orders.screen.scss'],
})
export class ProposalsAndOrdersComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  response: any;
  initData: any;
  dataSource: MatTableDataSource<string>;
  displayedColumns: string[];
  company: Company;
  activeTab: string;
  searchTerm = '';
  isLoading = true;
  server = '';

  constructor(
    private storageService: StorageService,
    private proposalsAndOrdersApiService: ProposalsAndOrdersService,
  ) {}

  async ngOnInit() {
    this.server = this.storageService.getJSON('SERVER');
    this.displayedColumns = [
      'magentoCartId',
      'magentoOrderId',
      'userId',
      'patient.companyId',
      'status',
      'products',
      'createdAt',
    ];

    this.activeTab = this.storageService.getJSON('ACTIVE_TAB');
    this.activeTab ? this.dataList(this.activeTab) : this.dataList();
  }

  private padTo2Digits(num) {
    return num.toString().padStart(2, '0');
  }

  async dataList(type = 'proposals') {
    this.isLoading = true;
    this.dataSource = null;
    this.activeTab = type;
    type === 'orders'
      ? (this.response = await this.proposalsAndOrdersApiService.getOrders())
      : (this.response = await this.proposalsAndOrdersApiService.getProposals());

    // Workaround for enabling date filtering
    this.initData = this.response.data;
    this.response.data.forEach((d, i) => {
      const a = new Date(d.createdAt);
      this.response.data[i].createdAt = `${a.getFullYear()}-${this.padTo2Digits(
        a.getMonth() + 1,
      )}-${this.padTo2Digits(a.getDate())}`;
    });

    this.setDataSource(this.response.data);
  }

  sortData(sort: Sort) {
    const data = this.response.data.slice();
    if (!sort.active || sort.direction === '') {
      return;
    }

    this.response.data = data.sort((a, b) => {
      this.response.data = this.initData;
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'magentoCartId':
          return this.compare(a.magentoCartId, b.magentoCartId, isAsc);
        case 'magentoOrderId':
          return this.compare(a.magentoOrderId, b.magentoOrderId, isAsc);
        case 'patient.companyId':
          this.dataSource.sortingDataAccessor = (obj, property) => this.getProperty(obj, property);
          break;
        case 'createdAt':
          return this.compare(a.createdAt, b.createdAt, isAsc);

        default:
          return 0;
      }
    });
  }

  private compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  private getProperty = (obj, path) => path.split('.').reduce((o, p) => o && o[p], obj);

  private async setDataSource(data) {
    this.isLoading = false;
    this.dataSource = new MatTableDataSource<string>(data);
    this.dataSource.filterPredicate = (data, filter) => {
      const dataStr = JSON.stringify(data).toLowerCase();
      return dataStr.indexOf(filter) != -1;
    };
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.storageService.storeJSON('ACTIVE_TAB', this.activeTab);
  }

  filterResults() {
    this.dataSource.filter = this.searchTerm.trim().toLowerCase();
  }
}
